import * as React from "react";
const SvgDocumentPile = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M8 2h6v6h6v10H8c-.088 0-.002-14.165 0-16" }),
    React.createElement("path", { fill: "currentColor", d: "M6 7H4v15h12v-2H6zM16 6V2l4 4z" })));
export default SvgDocumentPile;
//# sourceMappingURL=DocumentPile.js.map